import { render, staticRenderFns } from "./UpgradeWarning.vue?vue&type=template&id=0cf3027f&"
import script from "./UpgradeWarning.vue?vue&type=script&lang=js&"
export * from "./UpgradeWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports